<div class="mobile-header-v2">
  @if (selectionActive()) {
    <div class="state-c">
      <div class="header-bar">
        <button
          type="button"
          class="selection-cancel"
          [attr.aria-label]="'COMMON.CANCEL' | translate"
          (click)="selectionCancel.emit()"
        >
          <span class="ui-icon-close"></span>
        </button>
        <span class="selection-label" aria-live="polite">{{
          selectionLabel()
        }}</span>
        @if (showSelectAll()) {
          <button
            type="button"
            class="selection-select-all"
            uiTouchFeedback
            (click)="selectionSelectAll.emit()"
          >
            {{
              (allSelected() ? 'COMMON.DESELECT_ALL' : 'COMMON.SELECT_ALL')
                | translate
            }}
          </button>
        }
      </div>
    </div>
  }

  @if (!filterMode() && !selectionActive()) {
    <div class="state-a">
      <div class="header-bar">
        <div class="header-left">
          @if (showBackButton()) {
            <button class="back-btn" (click)="backClick.emit()">
              <span class="ui-icon-arrow"></span>
            </button>
          } @else {
            <ng-content select="[headerStart]" />
          }
          <div
            class="header-title-group"
            uiTouchFeedback
            [class.interactive]="isTitleInteractive()"
            [attr.role]="isTitleInteractive() ? 'button' : null"
            [attr.tabindex]="isTitleInteractive() ? 0 : null"
            [attr.aria-haspopup]="isTitleInteractive() ? 'dialog' : null"
            (click)="onTitleClick()"
            (keydown.enter)="onTitleClick()"
            (keydown.space)="onTitleClick(); $event.preventDefault()"
            (pointerdown)="onTitlePointerDown($event)"
            (pointermove)="onTitlePointerMove($event)"
            (pointerup)="clearTitleLongPress()"
            (pointercancel)="clearTitleLongPress()"
            (pointerleave)="clearTitleLongPress()"
            (contextmenu)="isTitleInteractive() && $event.preventDefault()"
          >
            <span class="header-title-stack">
              <span class="header-title" [class.has-subtitle]="!!subtitle()">
                <span
                  class="header-title-text"
                  uiTruncateText
                  [class.renamed]="titleRenamed()"
                >
                  @if (title()) {
                    {{ displayTitle() }}
                  } @else if (titlePlaceholder()) {
                    <span class="header-title-placeholder">{{
                      titlePlaceholder() | translate
                    }}</span>
                  }
                </span>
                @if (titleAffixIcon(); as affixIcon) {
                  <span class="title-affix" [class]="affixIcon"></span>
                }
              </span>
              <ng-content select="[headerSubtitle]" />
              @if (subtitle()) {
                <span class="header-subtitle" uiTruncateText>
                  {{ subtitle() | translate }}
                </span>
              }
            </span>
          </div>
        </div>
        <div class="header-spacer"></div>
        @if (showFilterTrigger()) {
          <button
            class="filter-trigger"
            uiTouchFeedback
            [class.active]="hasActiveFilters()"
            (click)="openFilterMode()"
          >
            <span class="ui-icon-filters-trigger"></span>
            @if (hasActiveFilters()) {
              <span class="ui-icon-dot active-dot"></span>
            }
          </button>
        }
        <ng-content select="[headerActions]" />
      </div>
    </div>
  }

  @if (filterMode() && !selectionActive()) {
    <div class="state-b">
      @if (searchPlaceholder()) {
        <div class="filter-top-bar">
          <button class="back-btn" (click)="closeFilterMode()">
            <span class="ui-icon-arrow"></span>
          </button>
          <div
            class="search-bar"
            (keydown.enter)="onSearchBarEnter($any($event.target).value)"
          >
            <ui-search
              #searchRef
              [placeholder]="searchPlaceholder() | translate"
              [formControl]="searchControl"
            />
          </div>
        </div>
      }

      <div class="pills-bar">
        @if (!searchPlaceholder()) {
          <button class="back-btn" (click)="closeFilterMode()">
            <span class="ui-icon-arrow"></span>
          </button>
        }
        <div class="pills-row">
          @for (def of filterDefs(); track def.key) {
            <button
              class="filter-pill"
              [class.active]="getActiveCount(def.key) > 0"
              [class.locked]="def.locked"
              (click)="onPillTap(def)"
            >
              @if (def.icon) {
                <span class="pill-icon" [class]="def.icon"></span>
              }
              {{ def.label | translate }}
              @if (def.locked) {
                @if (def.lockedValue) {
                  <span class="pill-locked-value">{{ def.lockedValue }}</span>
                }
                <span class="ui-icon-lock pill-lock"></span>
              } @else {
                @if (getActiveCount(def.key); as count) {
                  <span class="pill-badge">{{ count }}</span>
                }
                <mat-icon class="pill-chevron">expand_more</mat-icon>
              }
            </button>
          }
        </div>
      </div>

      @if (chips().length) {
        <div class="chips-row">
          <button class="clear-all-btn" (click)="onClearAll()">
            <mat-icon>close</mat-icon>
          </button>
          <div class="chips-scroll">
            @for (chip of chips(); track chip.filterKey + chip.value) {
              <span class="mobile-chip" (click)="onChipTap(chip)">
                @if (chip.icon) {
                  <span class="chip-icon" [class]="chip.icon"></span>
                }
                <span class="chip-label">{{ chip.label }}</span>
                <span
                  class="ui-icon-close chip-remove"
                  (click)="onChipRemove(chip); $event.stopPropagation()"
                ></span>
              </span>
            }
          </div>
        </div>
      }
    </div>

    @if (activeSheetKey()) {
      <ui-bottom-sheet
        [open]="true"
        [title]="activeSheetDef()?.label | translate"
        [stableHeight]="showSheetSearch()"
        (closeEmit)="closeSheet()"
      >
        @if (showSheetSearch()) {
          <ui-search
            sheet-search
            [placeholder]="'COMMON.SEARCH' | translate"
            [heightPx]="40"
            [debounceMs]="0"
            [formControl]="sheetSearchControl"
            (click)="$event.stopPropagation()"
            (keydown)="$event.stopPropagation()"
          />
        }

        <div sheet-content>
          <div class="sheet-options-list">
            @if (activeSheetDef()?.singleSelect) {
              <mat-radio-group
                [value]="localSheetValues()[0] ?? null"
                (change)="onRadioChange($event.value)"
              >
                @for (opt of filteredSheetOptions(); track opt.value) {
                  <mat-radio-button
                    [value]="opt.value"
                    class="sheet-radio-option"
                    uiTouchFeedback
                    (click)="onRadioChange(opt.value)"
                  >
                    {{ opt.label | translate }}
                  </mat-radio-button>
                }
              </mat-radio-group>
            } @else {
              @for (opt of filteredSheetOptions(); track opt.value) {
                <label
                  class="sheet-option"
                  (click)="toggleLocalValue(opt.value)"
                >
                  <span
                    class="custom-checkbox"
                    [class.checked]="localSheetValues().includes(opt.value)"
                  >
                    @if (localSheetValues().includes(opt.value)) {
                      <mat-icon>check</mat-icon>
                    }
                  </span>
                  <span
                    class="option-label"
                    [class.selected]="localSheetValues().includes(opt.value)"
                  >
                    {{ opt.label | translate }}
                  </span>
                </label>
              }
            }

            @if (showSheetSearch() && !filteredSheetOptions().length) {
              <ui-sheet-empty-state
                [query]="sheetSearchValue()"
                (clear)="sheetSearchControl.setValue('')"
              />
            }
          </div>
        </div>
        <div sheet-actions class="w-100">
          <ui-button
            class="w-100"
            [text]="
              ('COMMON.APPLY' | translate) +
              (localSheetValues().length
                ? ' (' + localSheetValues().length + ')'
                : '')
            "
            type="primary"
            size="l"
            (clickAction)="applySheet()"
          />
        </div>
      </ui-bottom-sheet>
    }
  }

  @if (titleEditable()) {
    @if (showTitleDropdown()) {
      <ui-bottom-sheet
        [open]="titleSheetOpen()"
        [title]="title() ? displayTitle() : (titlePlaceholder() | translate)"
        [subtitle]="subtitle() | translate"
        [titleCase]="false"
        (closeEmit)="titleSheetOpen.set(false)"
      >
        <div sheet-content class="title-sheet-list">
          <div class="title-sheet-card">
            <button
              type="button"
              class="title-sheet-row"
              uiTouchFeedback
              (click)="openRename()"
            >
              <span class="ui-icon-edit title-sheet-icon"></span>
              <span class="title-sheet-label">{{
                renameSheetTitle() | translate
              }}</span>
            </button>
            <button
              type="button"
              class="title-sheet-row"
              uiTouchFeedback
              (click)="onTitleSheetNavigate()"
            >
              <span class="ui-icon-sidebar title-sheet-icon"></span>
              <span class="title-sheet-label">{{
                resolvedTitleDropdownLabel() | translate
              }}</span>
            </button>
          </div>
        </div>
      </ui-bottom-sheet>
    }

    <ui-bottom-sheet
      [open]="renameOpen()"
      [title]="renameSheetTitle() | translate"
      [titleCase]="false"
      (closeEmit)="closeRename()"
    >
      <div sheet-content class="rename-field">
        @if (titleEditOptions()?.label; as label) {
          <label class="rename-label" for="ui-mobile-header-rename-input">{{
            label | translate
          }}</label>
        }
        <div class="rename-box" [class.invalid]="!!renameErrorKey()">
          <input
            #renameInput
            id="ui-mobile-header-rename-input"
            class="rename-input"
            type="text"
            autocomplete="off"
            enterkeyhint="done"
            [value]="renameValue()"
            [placeholder]="renamePlaceholder() | translate"
            [attr.maxlength]="renameMaxLength()"
            [attr.aria-invalid]="!!renameErrorKey()"
            [attr.aria-describedby]="
              renameErrorKey() ? 'ui-mobile-header-rename-error' : null
            "
            (input)="onRenameInput($any($event.target).value)"
            (keydown.enter)="submitRename(); $event.preventDefault()"
          />
          @if (renameValue()) {
            <button
              type="button"
              class="rename-clear"
              [attr.aria-label]="'COMMON.CLEAR' | translate"
              (mousedown)="$event.preventDefault()"
              (click)="clearRename()"
            >
              <span class="ui-icon-close"></span>
            </button>
          }
        </div>
        @if (renameErrorKey() || renameMaxLength() !== null) {
          <div class="rename-meta">
            <span class="rename-error" id="ui-mobile-header-rename-error">
              @if (renameErrorKey(); as errorKey) {
                {{ errorKey | translate: { name: renameValue().trim() } }}
              }
            </span>
            @if (renameMaxLength(); as maxLength) {
              <span
                class="rename-count"
                [class.warning]="renameCounterWarning()"
                >{{ renameValue().length }}/{{ maxLength }}</span
              >
            }
          </div>
        }
      </div>
      <div sheet-actions class="w-100">
        <ui-button
          class="w-100"
          [text]="'COMMON.SAVE' | translate"
          type="primary"
          size="l"
          [disabled]="!canSaveRename()"
          (clickAction)="submitRename()"
        />
      </div>
    </ui-bottom-sheet>
  }
</div>
